function Page404() {
  return <div>404 page</div>;
}

export default Page404;
